import classNames from 'classnames';
import React from 'react';

import useResponsive from '../../../hooks/useResponsive';
import { CarouselProvider, Slider, ButtonNext, ButtonPrev } from '../Carousel';
import Icon from '../Icon/Icon';
import Image from '../Image/Image';
import SnapSlider from '../SnapSlider/SnapSlider';
import { imgSizes } from '../WpImage/WpImage';
import * as styles from './Gallery.module.scss';

const Gallery = ({ className, images, isHero, ...other }) => {
  const { isMedium } = useResponsive();

  if (!images.length) {
    return null;
  }

  return isMedium ? (
    <CarouselProvider totalSlides={images.length}>
      <div
        className={classNames( className, {
          [ styles.isHero ]: isHero,
        })}
        {...other}
      >
        <div className={styles.inner}>
          <div className={styles.buttons}>
            <ButtonPrev className={styles.btnPrev}>
              <Icon name="chevron-left" />
            </ButtonPrev>
            <ButtonNext className={styles.btnNext}>
              <Icon name="chevron-right" />
            </ButtonNext>
          </div>
          <Slider transition="slide" autoHeight={false}>
            {images.map((image, index) => (
              <Image
                isPrimary={true}
                image={image}
                size={imgSizes.GALLERY_XLARGE}
                key={`carousel-child-${index}`}
              />
            ))}
          </Slider>
        </div>
      </div>
    </CarouselProvider>
  ) : (
    <SnapSlider
      className={classNames(className, { [ styles.isHero ]: isHero })}
      isHero={isHero}
      {...other}
    >
      {images.map((image, index) => (
        <Image
          isPrimary={true}
          image={image}
          size={imgSizes.GALLERY_SMALL}
          key={`snapslider-child-${index}`}
        />
      ))}
    </SnapSlider>
  );
};

export { Gallery };
